import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Menu from '@mui/material/Menu'
import MenuIcon from '@mui/icons-material/Menu'
import Container from '@mui/material/Container'
import Avatar from '@mui/material/Avatar'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import MenuItem from '@mui/material/MenuItem'
import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../context/AuthContext'
import { quitSession, quitSessionStudent } from '../../service/sessionService'
import { SessionContext } from '../../context/SessionContext'
import TutorialModal from '../commonUnit/TutorialModal'
import { ModeContext } from '../../context/ModeContext'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import CountDownTimer from './CountDownTimer'
import { AutoGroupingContext } from '../../context/AutoGroupingContext'
import {
  regrouping,
  setSessionRegrouping,
  setSessionGroupRound,
} from '../../service/sessionService'
import { SubmissionsContext } from '../../context/SubmissionsContext'
import { showToast } from '../commonUnit/Toast'
import { useNavigate } from 'react-router-dom'
import { isPythonFamily } from '../session/sessionSettings'
import ProfileModal from '../student-components/ProfileModal'
import SignUpModal from '../student-components/SignUpModal'
import Divider from '@mui/material/Divider'
import { getUserById } from '../../service/userService'
import { loadInstructorProfile } from '../../service/instructorService'
const pages = ['Products', 'Pricing', 'Blog']
const settings = ['Profile', 'Account', 'Dashboard', 'Logout']

function HeaderBanner() {
  const [anchorElNav, setAnchorElNav] = React.useState(null)
  const [anchorElUser, setAnchorElUser] = React.useState(null)
  const { currentUser, handleSignOut } = useContext(AuthContext)
  const { session, setSession, link } = useContext(SessionContext)
  const { Mode, setMode } = useContext(ModeContext)
  const { regroupingCheck } = useContext(AutoGroupingContext)

  const [profileModalOpen, setProfileModalOpen] = useState(false)
  const [signUpModalOpen, setSignUpModalOpen] = useState(false)
  const [userData, setUserData] = useState(null)

  const navigate = useNavigate()

  const fetchUserData = async () => {
    if (currentUser && currentUser.id) {
      try {
        let user
        if (currentUser.role === 2 || currentUser.role === 3 || currentUser.role === 4) {
          // For students (2 = TA, 3 = guest, 4 = real student account - all live in the
          // user table, not instructor)
          user = await getUserById(currentUser.id)
        } else {
          // For instructors
          user = await loadInstructorProfile(currentUser)
        }
        setUserData(user)
      } catch (error) {
        console.error('Error fetching user data:', error)
      }
    }
  }
  useEffect(() => {
    // Fetch user data when the component mounts
    fetchUserData()

    // Set up event listener for page load
    const handlePageLoad = () => {
      fetchUserData()
    }

    window.addEventListener('load', handlePageLoad)

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('load', handlePageLoad)
    }
  }, [currentUser])

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget)
  }
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget)
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null)
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null)
  }

  const handleOpenProfileModal = () => {
    setProfileModalOpen(true)
    handleCloseUserMenu()
  }

  const handleCloseProfileModal = () => {
    setProfileModalOpen(false)
  }

  const handleOpenSignUpModal = () => {
    setSignUpModalOpen(true)
    handleCloseUserMenu()
  }

  const handleCloseSignUpModal = () => {
    setSignUpModalOpen(false)
  }

  const handleOnComplete = async () => {
    if (currentUser.role < 3) {
      if (!session.stu_num || session.stu_num <= 2) {
        showToast('Please wait for more students', 'warning')
        return
      }
      await setSessionRegrouping(session.id, true)
      await regrouping(session, 3).then((res) => {
        if (res) {
          showToast('Grouping successfully.', 'success')
        } else {
          showToast('Grouping failed.', 'error')
          return
        }
      })
    }
    if (currentUser.role === 3 || currentUser.role === 4) {
      //Find out if added to new group or not
      // //console.log(currentUser)
    }
  }

  const handleSignOutClick = async () => {
    try {
      await handleSignOut()
      // redirect to login page
      if (currentUser.role < 3) {
        window.location.href = '/login'
      } else {
        window.location.href = window.location.href
      }
    } catch (err) {
      console.error('Failed to sign out:', err)
    }
  }

  const handleHomePage = () => {
    navigate('/about')
  }

  const handleQuitSession = () => {
    navigate('/session')
  }

  // Students in a Python session - with AI chat (Vizmental) or without - get no Session List
  // / Homepage links, so they stay on the exercise. Was Vizmental only.
  const hidesStudentNav =
    isPythonFamily(session?.type) && (currentUser.role === 3 || currentUser.role === 4)

  return (
    <AppBar position="static">
      <Container
        maxWidth="m"
        sx={{
          height: 1,
        }}>
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.1rem',
              color: 'inherit',
              textDecoration: 'none',
            }}>
            VizPI
          </Typography>

          {!hidesStudentNav && (
            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit">
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: 'block', md: 'none' },
                }}>
                <MenuItem onClick={handleCloseNavMenu}>
                  <Typography textAlign="center">Presenter View</Typography>
                </MenuItem>
                <MenuItem onClick={handleQuitSession}>
                  <Typography textAlign="center">Session List</Typography>
                </MenuItem>
              </Menu>
            </Box>
          )}

          {!hidesStudentNav && (
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
              {currentUser.email != null ? (
                <>
                  <Button
                    onClick={handleQuitSession}
                    sx={{ my: 2, color: 'white', display: 'block' }}>
                    Session List
                  </Button>
                  <Button
                    onClick={handleHomePage}
                    sx={{ my: 2, color: 'white', display: 'block' }}>
                    Homepage
                  </Button>
                </>
              ) : null}

              {currentUser.role < 3 ? (
                <>
                  <TutorialModal />
                </>
              ) : null}
            </Box>
          )}

          {hidesStudentNav && <Box sx={{ flexGrow: 1 }} />}

          {currentUser.role < 3 ? (
            <Typography
              variant="h6"
              noWrap
              component="a"
              sx={{
                flexGrow: 1,
                mr: 2,
                display: { xs: 'none', md: 'flex' },
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.1rem',
                color: 'inherit',
                textDecoration: 'none',
              }}>
              {link}
            </Typography>
          ) : null}
          {(currentUser.role === 3 || currentUser.role === 4) && session?.regrouping ? (
            <Typography
              variant="h6"
              noWrap
              component="a"
              sx={{
                flexGrow: 1,
                mr: 2,
                display: { xs: 'none', md: 'flex' },
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.1rem',
                color: 'inherit',
                textDecoration: 'none',
              }}>
              Entering New group in 5 Seconds
            </Typography>
          ) : null}
          {session?.type == 'Auto Grouping' &&
          session?.group_round === 1 &&
          regroupingCheck ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <CountDownTimer
                duration={20}
                colors={['#ff9248', '#a20000']}
                colorValues={[40, 10]}
                onComplete={handleOnComplete}
              />
              <Typography
                variant="h6"
                noWrap
                component="a"
                sx={{
                  flexGrow: 1,
                  mr: 2,
                  display: { xs: 'none', md: 'flex' },
                  fontFamily: 'monospace',
                  fontWeight: 700,
                  letterSpacing: '.1rem',
                  color: 'inherit',
                  textDecoration: 'none',
                }}>
                Until new Group
              </Typography>
            </div>
          ) : null}
          {(currentUser.role === 3 || currentUser.role === 4) && session?.group_round === 2 ? (
            <Typography
              variant="h6"
              noWrap
              component="a"
              sx={{
                flexGrow: 1,
                mr: 2,
                display: { xs: 'none', md: 'flex' },
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.1rem',
                color: 'inherit',
                textDecoration: 'none',
              }}>
              Welcome to your new group, please use the chat to help and get
              help
            </Typography>
          ) : null}

          {/* Guests (role 3) have nothing under this menu during an active Vizmental
              session worth showing (no account, just "Make an Account"), so it stays
              hidden for them - but role 4 is a real signed-up account and needs "My
              Exercises"/"Profile"/"Sign Out" to stay reachable even mid-session. This was
              briefly regressed to hide for role 4 too by the blanket role===3 -> role===3||4
              fix in 0c135b2db; narrowed back to role 3 only here. */}
          {!(session?.type === 'Vizmental' && currentUser.role === 3) && (
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar
                    alt={userData?.first_name || currentUser?.first_name}
                    src={userData?.avatar_url || ''}
                    sx={{
                      width: 40,
                      height: 40,
                      border: '2px solid',
                      borderColor: 'background.paper',
                    }}
                  />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}>
                <List>
                  <ListItem>
                    <Typography textAlign="center">
                      Hi{' '}
                      {userData?.first_name || currentUser?.first_name || 'there'}
                      !
                    </Typography>
                  </ListItem>
                </List>
                <Divider />
                {(currentUser.role === 2 || currentUser.role === 3 || currentUser.role === 4) &&
                  currentUser.email != null && (
                    <MenuItem onClick={handleOpenProfileModal}>
                      <Typography textAlign="center">Profile</Typography>
                    </MenuItem>
                  )}
                {currentUser.role === 4 && currentUser.email != null && (
                  <MenuItem onClick={() => { handleCloseUserMenu(); navigate('/my-exercises') }}>
                    <Typography textAlign="center">My Exercises</Typography>
                  </MenuItem>
                )}
                {(currentUser.role === 2 || currentUser.role === 3) &&
                  currentUser.email == null && (
                    <MenuItem onClick={handleOpenSignUpModal}>
                      <Typography textAlign="center">Make an Account</Typography>
                    </MenuItem>
                  )}
                {currentUser.role === 1 && (
                  // Same ProfileModal as UserProfileSession.jsx's "Settings" entry (it
                  // already has the Reset Password flow) - relabeled to match rather than
                  // leaving this, separate top bar used by the Exercise Editor page, the
                  // only place still calling it "Manage Profile".
                  <MenuItem onClick={handleOpenProfileModal}>
                    <Typography textAlign="center">Settings</Typography>
                  </MenuItem>
                )}
                <MenuItem onClick={handleSignOutClick}>
                  <Typography textAlign="center">Sign Out</Typography>
                </MenuItem>
              </Menu>
            </Box>
          )}
        </Toolbar>
      </Container>
      <ProfileModal open={profileModalOpen} onClose={handleCloseProfileModal} />
      <SignUpModal open={signUpModalOpen} onClose={handleCloseSignUpModal} />
    </AppBar>
  )
}

export default HeaderBanner
